module.exports = __webpack_public_path__ + "static/img/ikona_cw3-OFF.acc3fb7f.png";